import request from '@/utils/request'
export function fetchList(data) {
  return request({
    url:'/shoppingCart/list',
    method:'post',
    data:data
  })
}

export function createCart(data) {
  return request({
    url:'/shoppingCart/add',
    method:'post',
    data:data
  })
}

export function editCart(data) {
  return request({
    url:'/shoppingCart/edit',
    method:'post',
    data:data
  })
}


export function delCart(data) {
  return request({
    url:'/shoppingCart/delete',
    method:'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/cart.js